import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'postbacks/';

export default {
    createPostback: (fullUrl, affiliateSystemId, siteBrandLinkId) => {
        return api.post(BASE_URL, { fullUrl, affiliateSystemId, siteBrandLinkId });
    },
    getPostbackLog: (userId, {from, to}) => {
        return api.get(`${BASE_URL}${userId}`, {params: {from, to}});
    },
    getPostbackLogAdmin: (userId, {from, to}) => {
        return api.get(`${BASE_URL}admin/${userId}`, {params: {from, to}});
    },
    /**
     * Cheap check — does the current scope have any postbacks with
     * params.param1 set? Drives whether the "Params breakdown" tab is
     * visible. Server figures out scope from the JWT.
     */
    hasParamsPostbacks: ({ from, to } = {}) => {
        return api.get(`${BASE_URL}has-params`, { params: { from, to } });
    },
    /**
     * Aggregation over Postback.params.paramN. groupBy is optional string[]
     * like ['param1', 'param2']. Server whitelists to /^param\d+$/.
     */
    getParamsBreakdown: ({ from, to, groupBy } = {}) => {
        return api.get(`${BASE_URL}params-breakdown`, {
            params: {
                from,
                to,
                groupBy: Array.isArray(groupBy) ? groupBy.join(',') : groupBy,
            },
        });
    },
    /**
     * Every linked site link with the names a human can pick by. Feeds the
     * postback checker's picker. Admin-only server-side.
     */
    getTestableLinks: () => api.get(`${BASE_URL}testable-links`),
    /**
     * Read-only readiness check — resolves where a reg/ftd/cpa event for this
     * link would be forwarded. Sends nothing. Omit eventType for all three.
     */
    getTestPreview: (siteBrandLinkId, eventType) => {
        return api.get(`${BASE_URL}test-preview`, { params: { siteBrandLinkId, eventType } });
    },
    /**
     * Test-link: resolve a pasted tracking link's redirect chain, match our
     * SiteBrandLink and preview where a reg would route. Sends nothing. Admin-only.
     */
    resolveTestLink: (url) => api.post(`${BASE_URL}test-link`, { url }),
    /**
     * Fire the reg for a resolved plan (from resolveTestLink's sendPlan) and read
     * back the result. Outward-facing — forwards a real conversion. Admin-only.
     */
    sendTestReg: (plan) => api.post(`${BASE_URL}test-link/send`, plan),
}

